
import Vue from "vue";
import { AutoSaleRowSetting } from "@/models/auto-sale-row-setting";
import "codemirror/mode/javascript/javascript";
import { SaleType } from "@/models/sale-type";
import { ISelectItem } from "winfakt-vue-components";
import {  getEnumValueFromKey } from "@/utils/enum";
import { getVatRegimes, VatRegime } from "@/utils/vat-regimes";

export default Vue.extend({
	data(){
		return {
			setting: new AutoSaleRowSetting()
		};
	},
	props: {
		value: {
			type: Object as ()=>AutoSaleRowSetting,
			required: true
		},
		saleTypes: {
			type: Array as ()=>SaleType[],
			required: true
		}
	},
	computed: {
		saleTypeItems():ISelectItem<number>[] {
			return this.saleTypes.map(s=>{
				return {
					text: s.DisplayedName,
					value: s.ID
				};
			});
		},
		cmOptions():any{
			return {
				mode: "text/javascript"
			};
		},
		vatRegimeTypeItems():ISelectItem<number>[]{
			return getVatRegimes().map(k=>{
				return {
					text: getEnumValueFromKey(VatRegime, `${k}`),
					value: k
				};
			});
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.setting = new AutoSaleRowSetting(this.value);
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", new AutoSaleRowSetting(this.setting.getJSON()));
			this.close();
		}
	}
});
